import toJS from './toJS';

export default toJS;
